var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.affix ? "toc-affix" : "" }, [
    _c("div", { staticClass: "vab-anchor-wrapper" }, [
      _c(
        "div",
        { staticClass: "vab-anchor" },
        [
          _c("div", { staticClass: "vab-anchor-ink", style: _vm.style }, [
            _c("span", {
              ref: "inkNode",
              class: ["vab-anchor-ink-ball", _vm.activeLink ? "visible" : ""],
            }),
          ]),
          _vm._t("default"),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }